var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 122 147",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--Book-pickup-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ready-for-pick-up----small-screen---thank-you",
    transform: "translate(-134.000000, -117.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2.6666666
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(195.000000, 190.500000) scale(-1, 1) rotate(-180.000000) translate(-195.000000, -190.500000) translate(136.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 40,
    x2: 59,
    y2: 2.84217094e-14,
    id: "path274"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path276",
    points: "77.6284737 82 118 65.0454412 118 24.7792157 59 5.68434189e-14 2.47378653e-14 24.7792157 2.47378653e-14 65.0454412 40.3715263 82"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path278",
    points: "118 65 59 40 2.96364525e-14 65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,65 C66.0373333,88.493912 87,93.367664 87,114.92 C87,130.03016 73.6035556,143 59,143 C44.3964444,143 31,130.03016 31,114.92 C31,93.367664 51.9626667,88.493912 59,65 Z",
    id: "path280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4984232,125 C63.7458921,125 68,120.74559 68,115.498728 C68,110.25441 63.7458921,106 58.4984232,106 C53.2541079,106 49,110.25441 49,115.498728 C49,120.74559 53.2541079,125 58.4984232,125 Z",
    id: "path282"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 37,
    x2: 106,
    y2: 31,
    id: "path284"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 34,
    x2: 96,
    y2: 28,
    id: "path286"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f3f00267c9e0150fc7e12477c7d02523.svg";
export { ForwardRef as ReactComponent };